/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { HtmlHeadInclude } from '@msdyn365-commerce/core-internal';
import * as React from 'react';
import { ILiquidScriptViewProps } from './liquid-script';

export default (props: ILiquidScriptViewProps) => {
    const { 
        scriptSource,
        identifier
    } = props;

    return (
        <HtmlHeadInclude>
            <script data-load-point='headStart' id={identifier} async src={scriptSource} />
        </HtmlHeadInclude>
    );
};
